import { render } from "./SiteButton.vue?vue&type=template&id=71c6cbda"
import script from "./SiteButton.vue?vue&type=script&lang=js"
export * from "./SiteButton.vue?vue&type=script&lang=js"

import "./SiteButton.vue?vue&type=style&index=0&id=71c6cbda&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__